import clsxm from '@/lib/clsxm';

import { CardProps, CardStylesClassNames } from '@/components/card';
import HygraphImage from '@/components/hygraph-image';
import HygraphRichText from '@/components/hygraph-rich-text';
import Typography from '@/components/typography';

import { CardStyle } from '@/enums/card-style';

export function HorizontalImageTextCard({
  caption,
  body,
  image,
  className,
}: CardProps) {
  if (!image && !caption && (typeof body === 'string' || !body?.content))
    return null;

  return (
    <div
      className={clsxm(
        CardStylesClassNames[CardStyle.HORIZONTAL_IMAGE_TEXT],
        className
      )}
    >
      {image && (
        <HygraphImage
          {...image}
          width={80}
          height={80}
          imgClassName='h-10 w-10 max-w-none'
        />
      )}
      <div className='max-w-full break-words px-5'>
        {caption && (
          <Typography.Heading6 as='h6' className='mb-2'>
            {caption}
          </Typography.Heading6>
        )}
        {typeof body === 'string' ? (
          <Typography.Subtitle2 className='mb-4'>{body}</Typography.Subtitle2>
        ) : (
          body?.content && <HygraphRichText content={body.content} />
        )}
      </div>
    </div>
  );
}
